document.addEventListener("DOMContentLoaded", function () {
    console.log("🚀 File Upload Script Loaded for Shared Hosting.");

    // File upload input fields
    const fileInputCart = document.getElementById("file-upload-cart");
    const fileInputDrawer = document.getElementById("file-upload-drawer");
    const cartCheckoutButton = document.querySelector(".cart_checkout");
    const drawerCheckoutButton = document.querySelector(".js-cart-btn-checkout");
    const cartUploadSection = document.getElementById("cart-upload-section");
    const drawerUploadSection = document.getElementById("drawer-upload-section");
    
    // Loading overlay
    const overlay = document.getElementById("file-upload-overlay");

    // Your PHP upload script URL
    const uploadUrl = "https://www.weblerz.com/OLD/upload.php"; // Replace with your actual upload.php URL

    function showLoading() {
        if (overlay) {
            overlay.style.display = "flex";
        }



      
        if (cartCheckoutButton) {
            cartCheckoutButton.setAttribute("disabled", "true");
        }
        if (drawerCheckoutButton) {
            drawerCheckoutButton.setAttribute("disabled", "true");
        }
    }

    function hideLoading() {
        if (overlay) {
            overlay.style.display = "none";
        }
        if (cartCheckoutButton) {
            cartCheckoutButton.removeAttribute("disabled");
        }
        if (drawerCheckoutButton) {
            drawerCheckoutButton.removeAttribute("disabled");
        }
    }

    function uploadFile(fileInput) {
        if (!fileInput || !fileInput.files.length) {
            console.error("❌ No file selected!");
            return;
        }

        const file = fileInput.files[0];
        console.log("📤 Uploading file:", file.name);
        showLoading();

        const formData = new FormData();
        formData.append("file", file);

        fetch(uploadUrl, {
            method: "POST",
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            hideLoading();
            if (data.url) {
                console.log("🌐 Uploaded File URL:", data.url);

                return fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        attributes: {
                            "Uploaded File": data.url
                        }
                    })
                });
            } else {
                throw new Error("❌ File upload failed.");
            }
        })
        .then(response => response.json())
        .then(cartData => {
            console.log("🛒 Shopify response:", cartData);
            alert("✅ File uploaded successfully!");
        })
        .catch(error => {
            console.error("❌ Error during upload:", error);
            alert("⚠️ File upload failed. Please try again.");
            hideLoading();
        });
    }

    // Listen for file selection in Cart Page
    if (fileInputCart) {
        fileInputCart.addEventListener("change", function () {
            uploadFile(fileInputCart);
        });
    }

    // Listen for file selection in Cart Drawer
    if (fileInputDrawer) {
        fileInputDrawer.addEventListener("change", function () {
            uploadFile(fileInputDrawer);
        });
    }

    // Prevent checkout if no file is uploaded (Cart Page)
    if (cartCheckoutButton) {
        cartCheckoutButton.addEventListener("click", function (event) {
            if (cartUploadSection && cartUploadSection.style.display !== "none" && (!fileInputCart || !fileInputCart.files.length)) {
                event.preventDefault();
                alert("⚠️ Please upload a file before proceeding to checkout.");
            }
        });
    }

    // Prevent checkout if no file is uploaded (Cart Drawer)
    if (drawerCheckoutButton) {
        drawerCheckoutButton.addEventListener("click", function (event) {
            console.log("🛑 Checkout Button Clicked (Cart Drawer)");
            if (drawerUploadSection && drawerUploadSection.style.display !== "none" && (!fileInputDrawer || !fileInputDrawer.files.length)) {
                event.preventDefault();
                alert("⚠️ Please upload a file before proceeding to checkout.");
            }
        });
    }

    // Hide the Upload Field If a File Is Already Uploaded in Any Place
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        if (cart.attributes && cart.attributes["Uploaded File"]) {
            console.log("📌 File already uploaded. Hiding the other upload field.");
            if (cartUploadSection) cartUploadSection.style.display = "none";
            if (drawerUploadSection) drawerUploadSection.style.display = "none";
        }
    });

    // Ensure Upload Fields Are Shown for Pakistan & Qatar
    fetch('https://ipinfo.io/json?token=1011db7f870a96')
        .then(response => response.json())
        .then(data => {
            console.log("🌍 User Country:", data.country);

            if (data.country === 'PK' || data.country === 'QA') {
                console.log("✅ User is in Pakistan or Qatar. Showing upload field.");
                if (cartUploadSection) cartUploadSection.style.display = "block";
                if (drawerUploadSection) drawerUploadSection.style.display = "block";
            } else {
                console.log("❌ User is not in Pakistan or Qatar. Hiding upload field.");
                if (cartUploadSection) cartUploadSection.style.display = "none";
                if (drawerUploadSection) drawerUploadSection.style.display = "none";
            }
        })
        .catch(error => console.error("❌ Error fetching country:", error));
});
